import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import withHeader from "../../../hocs/withHeader";
import PasswordResetEmail from "./PasswordResetEmail"
import queryString from "query-string";
import PasswordResetNewPass from "./PasswordResetNewPass";
import ConfirmEmailSent from "./ConfirmEmailSent";
import {clearCredentials} from "../../../../slices/userSlice";
import withFooter from "../../../hocs/withFooter";

function PasswordReset(props) {
    const urlParams = queryString.parse(props.location.search);
    const resetData = {
        userId: urlParams.id,
        resetHash: urlParams.resetHash,
        email: urlParams.email
    };
    const [passResetCase, setPassResetCase] = useState("EMAIL_VIEW");

    useEffect(() => {
        props.clearCredentials();
        if (resetData.resetHash !== undefined &&
            resetData.userId !== undefined &&
            resetData.email !== undefined) {
            setPassResetCase("NEW_PASS_VIEW");
        }
    }, []);

    const finishEmailSent = () => { setPassResetCase('EMAIL_SENT_VIEW') };
    const hashInvalidAction = () => { setPassResetCase('EMAIL_HASH_INVALID_VIEW') };

    function passwordResetCase(passResetCase) {
        switch (passResetCase) {
            case 'EMAIL_VIEW':
                return <PasswordResetEmail handleFinishSubmit={finishEmailSent} hashVerificationFailed={false} />;
            case 'EMAIL_HASH_INVALID_VIEW':
                return <PasswordResetEmail handleFinishSubmit={finishEmailSent} hashVerificationFailed={true} />;
            case 'EMAIL_SENT_VIEW':
                return <ConfirmEmailSent />;
            case 'NEW_PASS_VIEW':
                return <PasswordResetNewPass resetData={resetData} hashInvalidAction={hashInvalidAction} />;
            default:
                return <PasswordResetEmail handleFinishSubmit={finishEmailSent} hashVerificationFailed={false}/>;
        }
    }

    return (
        <section className="password-change">
            {passwordResetCase(passResetCase)}
        </section>
    );
}

const mapDispatchToProps = { clearCredentials };



export default connect (null, mapDispatchToProps)(withFooter(withHeader(PasswordReset)));
